<template>
    <div style="display: flex; flex-direction: column; height: 100%">
      <van-nav-bar
        left-arrow
        title="工单详情"
        left-text="返回"
        @click-left="$emit('update:show', false)">
      </van-nav-bar>
      <div>
        <div style="display: flex;align-items: center;justify-content: space-around;">
            <input class="inputsearch" v-model="carselectName">
            <div class="btnsearch" @click="bindSearch">搜索</div>
        </div>
        <div style="width: 96%;margin: 0px auto;display: flex;">
            <div style="width: 50%;position: relative;">
                <div class="modelName" v-for="(item,index) of oldcarList" :key="item.id" @click="showBrandmodel(index,$event)"
                 :style="{color:brandmodel===index?'#1890FF':''}" ref="brandTop">
                    {{item.name}}
                </div>
            </div>
            <div style="width: 50%;position:absolute;left: 50%;" :style="{'margin-top':topGap +'px'}" v-show="showbrand">
                <div style="min-height: 30px;" v-for="(val,index) of brandmodelList" :key="val" @click="btnBrandmodel(index)">
                    {{val}}
                    <div class="line"></div>
                </div>
            </div>
        </div>
      </div>

    </div>
  </template>

  <script>
    import { NavBar } from 'vant'

    export default {
      name: 'WxCarselectPanel',
      components: {
        [NavBar.name]: NavBar
      },
      props: {
        brand: {
          type: Array,
          required: true
        },
        workCop: {
          type: Object,
          required: true
        }
      },
      data () {
        return {
            showbrand: false,
            brandmodel: '',
            brandmodelList: [],
            topGap: 0,
            carselectName: '',
            oldcarList: this.$store.state.data.BrandModel,
            newcarList: [],
            unshiftList: []// 需要替换的列表,
        }
      },
      created () {
        // 将门店设置的品牌替换至第一位
        var _this = this
        _this.$store.state.shop.carBandIds.forEach((val, index1) => {
            _this.oldcarList.forEach((item, index2) => {
                if (val === item.id) {
                    _this.unshiftList.push(_this.oldcarList[index2])
                    _this.oldcarList.splice(index2, 1)
                }
            })
        })
        _this.unshiftList.forEach((v, i) => {
            _this.oldcarList.unshift(v)
        })
      },
      methods: {
        showBrandmodel (index, e) {
            this.showbrand = true
            this.brandmodel = index
            this.brandmodelList = this.oldcarList[index].models
            // console.log(e.currentTarget.offsetTop)
            this.topGap = e.currentTarget.offsetTop
        },
        btnBrandmodel (index) {
            this.brand[0] = this.oldcarList[this.brandmodel].id
            this.brand[1] = this.oldcarList[this.brandmodel].models[index]
            this.workCop.brandModel = this.brand
            this.$emit('update:show', false)
        },
        bindSearch () {
            // 清楚选中
            this.showbrand = false
            this.brandmodel = ''
            var _this = this
            if (_this.carselectName !== '') {
                _this.newcarList = []
                _this.oldcarList.filter(item => {
                    if (item.name.indexOf(_this.carselectName) !== -1) {
                        _this.newcarList.push(item)
                        _this.oldcarList = _this.newcarList
                    }
                })
            } else {
                _this.oldcarList = this.$store.state.data.BrandModel
             }
        }
      }
    }
  </script>

  <style lang="scss" scoped>
        .inputsearch{
            border-radius: 10px;
            height: 30px;
            border: 1px solid black;
            width: 80%;
        }
        .btnsearch{
            width: 40px;
            height: 30px;
            border: 1px solid black;
            border-radius: 10px;
            text-align: center;
            line-height: 30px;
            font-size: 15px;
        }
        .line{
            width: 100%;
            height: 1px;
            background-color: #1890FF;
        }
        .modelName{
            min-height: 30px;
            color: black;
            margin: 5px 0px;
        }
  </style>
